import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import CommonModal from '../../../common/Modal';
import PropTypes from 'prop-types';
import './index.scss';
const { API } = require('../../../../config/' + process.env.REACT_APP_ENV);

const EmbedChartModal = ({
  closeDialogHandler,
  exportChart,
  dynamicChartData,
  drugName
}) => {
  const [copiedText, setcopiedText] = useState(false);
  const [dynamicScript, setdynamicScript] = useState('');
  useEffect(() => {
    setTimeout(() => {
      document.body.style.overflow = 'hidden';
    }, 10);
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);
  useEffect(() => {
    setdynamicScript(`<link rel="stylesheet" href="${dynamicChartData.location}/singlecare-chart.css" />
    <div id=${dynamicChartData.searchDrugName}></div>
    <script defer src="${dynamicChartData.location}/singlecare-chart.js" data-searchDrugName="${dynamicChartData.searchDrugName}" ></script>`);
  }, [dynamicChartData]);
  const onCopyClipBoard = () => {
    const textField = document.createElement('textarea');
    textField.innerText = dynamicScript;
    setcopiedText(true);
    setTimeout(() => {
      setcopiedText(false);
    }, 2000);
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
  };
  return (
    <div className="embedChartWrapper">
      <CommonModal
        closeDialogHandler={closeDialogHandler}
        closeButtonIMG="icon-close-white.svg"
        isInitialFocusToClose={true}
      >
        <div className="embedChartModal">
          <h3 className="title">Embed this chart</h3>
          {API.ALLOW_EMBED_PRICE_CHART && (
            <div className="mainWrapper">
              <img
                src="/content/images/icons/embed-1.svg"
                height="48"
                width="48"
                alt=""
              />
              <p className="heading">Embed with dynamic data</p>
              <p className="description">
                Chart updates each month to show new price fluctuations, plus
                data from the previous 12 months.
              </p>
              <p className="linkHeading">
                Copy/paste this code to your website:
              </p>
              <div className="urlCopyWrap">
                <p className="textWrap copy">{dynamicScript}</p>
                <button
                  className="copyButton desktop-only dialogComponent themeFocus"
                  onClick={() => onCopyClipBoard()}
                >
                  {copiedText ? 'Copied' : 'Copy'}
                </button>
                <button
                  className="copyButtonMobile mobile-only"
                  onClick={() => onCopyClipBoard()}
                >
                  <img
                    src="/content/images/icons/copy-icon.svg"
                    className="mobile-only"
                    height="16px"
                    width="16px"
                    alt=""
                  />
                  {`${copiedText ? 'Copied' : 'Copy'} to clipboard`}
                </button>
              </div>
            </div>
          )}
          <div className="mainWrapper">
            <img
              src="/content/images/icons/embed-2.svg"
              height="48"
              width="48"
              alt=""
            />
            <p className="heading">Embed with static data</p>
            <p className="description">
              Chart shows a snapshot of data from the previous 12 months, dating
              back from your download.
            </p>
            <p className="linkHeading">
              Download this file and add it to your website:
            </p>
            <div className="downloadWrap">
              <p className="textWrap">
                {drugName}-singlecare-price-history.png
              </p>
              <button
                className="downloadButton dialogComponent themeFocus"
                onClick={exportChart}
              >
                <img
                  src="/content/images/icons/download-icon.svg"
                  className="mobile-only"
                  height="11px"
                  width="7px"
                  alt=""
                />
                Download
              </button>
            </div>
          </div>
        </div>
      </CommonModal>
    </div>
  );
};
EmbedChartModal.propTypes = {
  closeDialogHandler: PropTypes.func,
  exportChart: PropTypes.func,
  copyToClipboard: PropTypes.func,
  dynamicChartData: PropTypes.object,
  drugName: PropTypes.string
};

EmbedChartModal.defaultProps = {
  closeDialogHandler: () => {},
  exportChart: () => {},
  copyToClipboard: () => {},
  dynamicChartData: {},
  drugName: ''
};

export default withTranslation()(EmbedChartModal);
